$primary-color: #7fb02f;

.container {
	padding: 0;
	border-radius: 0.5rem;
	padding: 1rem;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
	padding-bottom: 0.75rem;
	border-bottom: 2px solid rgba(127, 176, 47, 0.2);
}

.title {
	font-size: 0.95rem;
	font-weight: 600;
	color: #111827;
	margin: 0;
}

.subtitle {
	font-size: 0.85rem;
	color: #6b7280;
}

.tableWrapper {
	overflow-x: auto;
	border-radius: 0.5rem;
	border: 1px solid #e5e7eb;

	&::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #a8a8a8;
		border-radius: 15px;
	}
}

.table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.875rem;
	background: #fff;
}

.thead {
	background: #f9fafb;
}

.th {
	text-align: left;
	padding: 0.5rem 0.75rem;
	border-bottom: 1px solid #e5e7eb;
	color: #111827;
	font-weight: 600;
	font-size: 0.7rem;
	white-space: nowrap;
}

.tbody {
	background: #fff;
}

.tr {
	border-bottom: 1px solid #f3f4f6;
	transition: background-color 0.15s ease;
}

.tr:nth-child(even) {
	background: #fafafa;
}

.tr:hover {
	background: rgba(127, 176, 47, 0.05);
}

.td {
	padding: 0.5rem 0.75rem;
	color: #111827;
	white-space: nowrap;
}

.statusBadge {
	display: inline-block;
	padding: 0.25rem 0.75rem;
	border-radius: 9999px;
	font-size: 0.75rem;
	font-weight: 600;
	text-align: center;
	white-space: nowrap;
}

.statusPending {
	background-color: #fef3c7;
	color: #92400e;
}

.statusInProgress {
	background-color: #dbeafe;
	color: #1e40af;
}

.statusCompleted {
	background-color: #d1fae5;
	color: #065f46;
}

.empty {
	text-align: center;
	padding: 1.5rem;
	color: #9ca3af;
	font-size: 0.875rem;
}

.alignRight {
	text-align: right;
}

.alignCenter {
	text-align: center;
}
